import { FC, useEffect } from "react";
import { useWatch } from "react-hook-form";

import { EntityInput } from "@framework/mui-inputs-entity";

export interface ITemplateInputProps {
  data: any;
  name?: string;
  handleReset: () => void;
}

export const TemplateInput: FC<ITemplateInputProps> = props => {
  const { data, name = "templateId", handleReset } = props;

  const templateId = useWatch({ name });

  useEffect(() => {
    if (!templateId) {
      handleReset();
    }
  }, [templateId]);

  return <EntityInput name={name} controller="template" data={data} variant="outlined" />;
};
